'use client';

import React, { HTMLAttributes, ReactNode, forwardRef } from 'react';
import { VariantProps } from 'class-variance-authority';
import { variants } from './variants';
import { Icon, IconProps } from '../icon/Icon';

type ChipBaseProp = HTMLAttributes<HTMLDivElement> & {
	label: string | ReactNode;
	iconLeftProps?: IconProps;
	iconRightProps?: IconProps;
};

type ChipProps = ChipBaseProp &
	VariantProps<typeof variants> & {
		variant?: string;
		size?: string;
		outline?: boolean;
		rounded?: boolean;
	};

const Chip = forwardRef<HTMLDivElement, ChipProps>(
	({ variant, size, outline, className, rounded, label, iconLeftProps, iconRightProps }, ref) => {
		return (
			<div ref={ref} className={`${variants({ variant, size, outline, rounded, className })}`}>
				{iconLeftProps && <Icon {...iconLeftProps} />}
				{label}
				{iconRightProps && <Icon {...iconRightProps} />}
			</div>
		);
	},
);

Chip.displayName = 'Chip';

export { Chip };
